module.exports = __webpack_public_path__ + "static/media/boop.e83718ce.mp3";